import { LogentriesEnvironment } from "@dffedb/util";
import { EforsyningEnvironment } from "@e-forsyning/common/environment";

export const environment: EforsyningEnvironment & LogentriesEnvironment = {
    logentries: {
        application: "E|Forsyning",
        token: "6f65d82b-e060-4648-82a3-06481aca2c38"
    },
    production: false,
    matomoUrl: "https://matomo.eforsyning.dk/",
    pushApiUrl: "", // Use relative path - IIS proxy will forward /api/* to http://localhost:3000
    baseHref: "/" // Dette kan ændres dynamisk af Umbraco
};
